exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".c-display-template {\n  position: relative;\n  padding: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/displayTemplate/displayTemplate.scss
// module id = 655
// module chunks = 0